import { Delete, EditNote } from "@mui/icons-material";
import { Backdrop, Button, FormControl, FormControlLabel, Grid, IconButton, Radio, RadioGroup, Typography } from "@mui/material";
import axios from "axios";
import { useFormik } from 'formik';
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import * as yup from "yup";
import CustomDataGrid from "../../../../../components/dataTable/customDataGrid";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import Loader from "../../../../../components/loader/loader";
import DeletePage from "../../../../../components/utils/deleteModal/deletePage";
import CustomTextField from "../../../../../components/utils/input/customTextField";
import Modal from "../../../../../components/utils/modal/modal";
import { Helmet } from "react-helmet-async";
const AccountMaster = () => {
  const dispatch = useDispatch()
  const pageOption = [10, 25, 50, 100];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
  const [pageCount, setPageCount] = useState(0);
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);
  const [data, setData] = useState([])
  const [isEdit, setIsEdit] = useState(false)
  const [activeId, setActiveId] = useState(null)
  const [openDialog, setOpenDialog] = useState(false)
  const [isLoader, setIsLoader] = useState(false); //loader

  const columns = [
    {
      field: "sno",
      headerName: "S.no",
      flex: 1,
      minWidth: 70,
      maxWidth: 100,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "accName",
      headerName: "Account Type",
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "accType",
      headerName: "Transaction Category",
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    // {
    //   field: "active",
    //   headerName: "Status",
    //   flex: 1,
    //   headerAlign: "center",
    //   align: "center",
    //   sortable: false,
    //   disableColumnMenu: true,
    //   renderCell: (params) => (
    //     <div className="">
    //       <Switch checked={params.row.isActive}/>
    //     </div>
    //   )
    // },
    {
      field: 'action',
      headerName: 'Action',
      flex: 1,
      minWidth: 100,
      headerAlign: "center",
      align: "center",
      editable: false,
      sortable: false,
      disableExport: true ,
      disableColumnMenu: true,
      renderCell: (params) => (
        <div className='flex justify-center w-full'>
          <IconButton onClick={()=>onEdit(params.row)} >
            <EditNote sx={{color:"#1972d2",fontSize:22}}/>
          </IconButton>
          <IconButton onClick={() => OnDelete(params.id)}>
            <Delete sx={{color:"red",fontSize:22}}/>
          </IconButton>
        </div>
      ),
    },
  ];

  const rows = _.map(data , (val , idx) => ({
    id : val.id,
    sno: ++idx,
    accName : val.acname,
    accType : val.actype_id === 1 ? "Income" : "Expenses"
  }))

  const props = {
    rows: rows,
    columns: columns,
    search: search,
    setSearch: setSearch,
    page: page,
    setPage: setPage,
    rowsPerPage: rowsPerPage,
    setRowsPerPage: setRowsPerPage,
    pageCount: pageCount,
    pageOption: pageOption,
  };
  const validation = yup.object({
    accName:yup.string().matches(/^\S.*$/, "Empty space not allowed!").required('This field is required!'),
    accType:yup.string().required('This field is required!'),
  })
  const formik = useFormik({
    initialValues:{
      accName:"",
      accType:"",
    },
    validationSchema:validation,
    onSubmit: isEdit ? handleUpdate : handleCreate
    })
    const onCreate = () => {
      setOpen(true)
      formik.resetForm()
      setIsEdit(false)
    }
    function handleCreate(){
      const accData = {
       acname:formik.values.accName,
       actype_id:formik.values.accType === "Income" ? 1 : 0,
       company_id:1,
       is_active:1
      }
      setIsLoader(true);

      axios.post('/v1/accountmaster',accData)
    .then(res=>{
      setOpen(false)
      getAccountsData()
      dispatch(setSnackbar(true, 'success','Created Successfully!'))
      setOpen(false)
      setIsLoader(false);
    })
    .catch(err=>{
      console.log(err)
      dispatch(setSnackbar(true,'error',err.response.data.errors[0].message))
      setIsLoader(false);
    })
    }
    function onEdit(e){
      console.log(e)
      setIsEdit(true)
      setOpen(true)
      setActiveId(e.id)
      formik.setFieldValue('accName' , e.accName)
      formik.setFieldValue('accType' , e.accType)

    }
    function handleUpdate(){
      const accData = {
        acname:formik.values.accName,
        actype_id:formik.values.accType === "Income" ? 1 : 0,
        company_id:1,
        is_active:1
       }
      setIsLoader(true);

       axios.put(`/v1/accountmaster/${activeId}`,accData)
     .then(res=>{
       setOpen(false)
       getAccountsData()
       dispatch(setSnackbar(true, 'success','Updated Successfully!'))
       setOpen(false)
      setIsLoader(false);

     })
     .catch(err=>{
       console.log(err)
       dispatch(setSnackbar(true,'error',err.response.data.errors[0].message))
       setIsLoader(false);
     
      })
    }
    function OnDelete(id){
      setOpenDialog(true)
      setActiveId(id)
    }  
    const handleDelete = () =>{
      setIsLoader(true);

      axios.delete(`/v1/accountmaster/${activeId}`)
      .then(res=>{
        setOpenDialog(false)
        getAccountsData()
        console.log(res)
      setIsLoader(false);
      setOpen(false)
        dispatch(setSnackbar(true, 'success', 'Deleted Successfully'))
      })
      .catch(err=>{
        dispatch(setSnackbar(true, 'error',err.response.data.errors[0].message))
        console.log(err)
      setIsLoader(false);

      })
    }
    const getAccountsData = () =>{
      setIsLoader(true);

      axios.get(`/v1/accountmaster/${rowsPerPage}/${page + 1}`)
      .then(res=>{
        setData(res.data.data)
        setPageCount(res.data.meta.pagination.total)
      setIsLoader(false);

      })
      .catch(err=>{
        console.log(err)
        dispatch(setSnackbar(true, 'error', err.response.data.message))
        setIsLoader(false);
      
      })
    }
    console.log(formik.errors)
    useEffect(() => {
      getAccountsData()
    },[rowsPerPage, page, search])
  return (
    <Grid className="">
      <Helmet>
        <title>
          Accounts
        </title>
      </Helmet>
      <Typography variant="h5">Account Master</Typography>
      {!open &&
  <Grid className='flex justify-end'>
    <Button variant='contained' size='small' onClick={onCreate}>Create New</Button>
</Grid>}
{open &&
        <Modal onClose={setOpen} onSave={formik.handleSubmit} formik={formik} isEdit={isEdit}>
          <Grid container spacing={2}>
          <Grid item xs={12} md={4} lg={3}>
      <CustomTextField id='accName' value={formik.values.accName} title='Account Type' multiple={false} placeholder='Enter account type' onchange={formik.handleChange} errorMsg={formik.touched.accName && Boolean(formik.errors.accName)} helperText={formik.touched.accName && formik.errors.accName}/>
      </Grid>
      <Grid item xs={12}  md={4} lg={3} >
  <Typography variant="body1" my={1}>Transaction Category</Typography>
    <FormControl sx={{ display: "flex" }}>
      <RadioGroup
        aria-labelledby="demo-radio-buttons-group-label"
        name="accType"
        id="accType"
        sx={{ flexDirection: "row", display: "flex" }}
        onChange={formik.handleChange}
      >
        <FormControlLabel
          value="Income"
          control={<Radio size="small" checked={formik.values.accType === "Income"}/>}
          label="Income"
        />
        <FormControlLabel
          value="Expenses"
          control={<Radio size="small" checked={formik.values.accType === "Expenses"}/>}
          label="Expenses"
        />
      </RadioGroup>
      <Typography sx={{color:"red",fontSize:12}}>{formik.touched.accType && formik.errors.accType}</Typography>
    </FormControl>
  </Grid>
  {/* <Grid item xs={12} md={4} lg={3} className="flex items-center">
              <FormControlLabel control={<Checkbox />} label="Active" />
            </Grid> */}
          </Grid>
        </Modal>
      }
      <Grid className="bg-white rounded-md p-2 my-3">
        <CustomDataGrid props={props} />
      </Grid>
      <Backdrop open={openDialog} sx={{zIndex:1350}}>
  <DeletePage onCancel={setOpenDialog} onSubmit={handleDelete}/>
</Backdrop>
{/* <Loader isLoader={isLoader} /> */}
    </Grid>
  );
};

export default AccountMaster;
